<template>
  <el-dialog title="选择权益" :visible.sync="dialogVisible" width="1100px" @close="handleClose">
    <div class="add-equity-container">
      <!-- 搜索表单 -->
      <div class="new-top-bg-box new-input-box">
        <inputForm :inputData="myFormInfo" @toParentVal="recordQuery" :formData.sync="searchForm" :btnPosition1="true"
          :immediately="true"></inputForm>
      </div>

      <!-- 表格 -->
      <div class="new-bottom-bg-box new-input-box">
        <my-table ref="myTable" row-key="id" :tableInfo="myTableInfo" :pageInfo="pagination" :total="total"
          :tableData="tableData" @handlePage="handlePage" v-loading="loading" @selection-change="handleSelectionChange"
          :selection="true">
          <!-- 表头插槽 -->
          <template v-slot:benefitEnableIconUrl="scope">
            <img class="benefit-icon" :src="scope.row.benefitEnableIconUrl" />
          </template>
          <template v-slot:name="scope">
            {{ scope.row.name || "-" }}
          </template>
          <template v-slot:jumpInfo="scope">
            {{ scope.row.jumpInfo || "-" }}
          </template>
          <template v-slot:updateTime="scope">
            {{ scope.row.updateTime || "-" }}
          </template>
        </my-table>
      </div>

      <div class="add-link">
        <a href="javascript:;" style="color: #3159ff" @click="goToAddEquity">去添加权益></a>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <jd-button @click="handleClose">取消</jd-button>
      <jd-button type="blue" @click="handleConfirm">确认</jd-button>
    </div>
  </el-dialog>
</template>

<script>
import inputForm from "@/components/jhk/inputForm";
import myTable from "@/views/interactiveMarketing/components/earnPointsTask/_components/myTable.vue";
import { getMemberBenefitInfo } from "@/api/integralCenter/equity.js";

export default {
  name: 'AddEquity',
  components: {
    inputForm,
    myTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 已选择的权益列表
    selectedEquities: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        name: '',
        updateStartTime: '',
        updateEndTime: ''
      },
      myFormInfo: [
        {
          name: "权益名称",
          val: "name",
          placeholder: "请输入权益名称",
        },
        {
          name: "最后修改时间",
          val: ["updateStartTime", "updateEndTime"],
          myDate: true,
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        }
      ],
      myTableInfo: [
        {
          label: "权益图标",
          prop: "benefitEnableIconUrl",
          minWidth: "150",
          slot: "benefitEnableIconUrl",
        },
        {
          label: "权益名称",
          prop: "name",
          minWidth: "150",
          slot: "name",
        },
        {
          label: "跳转链接",
          prop: "jumpInfo",
          minWidth: "200",
          slot: "jumpInfo",
        },
        {
          label: "最后修改时间",
          prop: "updateTime",
          minWidth: "180",
          slot: "updateTime",
        }
      ],
      tableData: [],
      loading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      // 当前选中的权益
      selectedRows: []
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.getEquityList();
      } else {
        // 关闭弹窗时清空选择
        this.selectedRows = [];
        if (this.$refs.myTable) {
          this.$refs.myTable.handleClearSelection();
        }
      }
    },
    selectedEquities: {
      handler(val) {
        if (this.dialogVisible && this.$refs.myTable && this.tableData.length > 0) {
          this.$nextTick(() => {
            this.setSelectedRows();
          });
        }
      },
      deep: true
    }
  },
  methods: {
    // 获取权益列表
    getEquityList() {
      this.loading = true;
      // 保存当前已选择的权益ID
      const selectedIds = this.selectedRows.map(item => item.id);

      let params = {
        name: this.searchForm.name,
        updateStartTime: this.searchForm.updateStartTime || "",
        updateEndTime: this.searchForm.updateEndTime || "",
        current: this.pagination.pageNum,
        size: this.pagination.pageSize,
      }
      // 获取权益列表
      getMemberBenefitInfo(params).then(res => {
        this.loading = false;
        console.log("--- res:---", res)
        if (res.code == 200 || res.code === 1) {
          this.tableData = res.data.records || [];
          this.total = Number(res.data.total);
          this.$nextTick(() => {
            this.setSelectedRows(selectedIds);
          });
        } else {
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.loading = false;
      })
    },

    // 设置已选中的权益
    setSelectedRows(additionalSelectedIds = []) {
      // 先清除所有选择
      if (this.$refs.myTable) {
        this.$refs.myTable.handleClearSelection();
      }

      // 保存当前不在页面上的已选项
      const selectedRowsNotInCurrentPage = this.selectedRows.filter(
        item => !this.tableData.some(row => row.id === item.id)
      );
      // 重置当前页面的选中状态
      const currentPageSelectedRows = [];
      if (this.tableData && this.tableData.length > 0) {
        // 遍历表格数据，找出已选择的项目
        this.$nextTick(() => {
          this.tableData.forEach(row => {
            // 1. 检查是否在父组件传入的已选择列表中
            const isSelectedFromProps = this.selectedEquities && this.selectedEquities.some(item =>
              (item.id === row.id) || (item.name === row.name && item.name)
            );
            // 2. 检查是否是用户在其他页面选择的项目
            const isSelectedByUser = additionalSelectedIds.includes(row.id);
            if (isSelectedFromProps || isSelectedByUser) {
              // 将已选项添加到当前页面选中数组
              currentPageSelectedRows.push(row);
              // 设置表格行选中状态
              if (this.$refs.myTable) {
                this.$refs.myTable.toggleRowSelection(row, true);
              }
            }
          });

          // 合并当前页面选中的行和其他页面选中的行
          this.selectedRows = [...currentPageSelectedRows, ...selectedRowsNotInCurrentPage];
          console.log("--- 已选择的权益: ---", this.selectedRows);
        });
      }
    },

    // 搜索查询
    recordQuery(form) {
      console.log("--- form:---", form)
      console.log("form>>", form);
      this.searchForm = form;
      console.log("---  this.searchForm:---", this.searchForm)
      this.pagination.pageNum = 1;
      this.getEquityList();
    },

    // 分页处理
    handlePage(pageInfo) {
      this.pagination.pageNum = pageInfo.pageNum || 1;
      this.pagination.pageSize = pageInfo.pageSize || 10;
      this.getEquityList();
    },

    // 选择变化
    handleSelectionChange(val) {
      // 获取当前页面的所有ID
      const currentPageIds = this.tableData.map(item => item.id);
      // 保留不在当前页面的已选项
      const selectedRowsNotInCurrentPage = this.selectedRows.filter(
        item => !currentPageIds.includes(item.id)
      );
      // 合并当前页面新选择的项目和其他页面已选择的项目
      this.selectedRows = [...val, ...selectedRowsNotInCurrentPage];
      console.log("--- this.selectedRows:---", this.selectedRows);
    },

    // 去添加权益
    goToAddEquity() {
      // 跳转到添加权益页面或打开添加权益弹窗
      window.open('/member/memberShipLevel');
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },

    // 确认选择
    handleConfirm() {
      // 最多选择20个
      if (this.selectedRows.length > 20) {
        this.$message.warning("最多只能选择20个权益");
        return;
      }
      this.$emit('confirm', this.selectedRows);
      this.handleClose();
    }

  }
}
</script>

<style scoped>
.add-equity-container {
  padding: 0 10px;
}

.add-link {
  cursor: pointer;
  margin-top: 16px;
  text-align: right;
  position: absolute;
  right: 24px;
  top: 138px;
}

.benefit-icon {
  width: 50px;
  height: 50px;
}

.new-top-bg-box {
  margin-bottom: 0px;
  padding-bottom: 0px !important;
  padding-left: 0;
  padding-top: 0;
}

.new-bottom-bg-box {
  border-radius: 8px;
}
</style>